<script>
  import Group from "$lib/admin/components/Group.svelte";
  import Input from "$lib/admin/components/Input.svelte";

  // props.buttonText:
  // props.buttonTextSub:
  // props.buttonLink:
  // props.buttonType:
  export let props = null;
  export let adminView = false;
</script>

{#if adminView}
  <Group colspan="4-8" addClass="form-item">
    <Input
      bind:value={props.buttonUrl}
      label="URL"
      placeholder="Write a URL"
      on:keyup />
  </Group>
  <Group colspan="4-8" addClass="form-item">
    <Input
      bind:value={props.buttonAnchor}
      label="Anchor"
      placeholder="Write an anchor"
      on:keyup />
  </Group>
{:else if !adminView && props}
  <a class={props.buttonType} href={props.buttonUrl}>{props.buttonAnchor}</a>
{/if}

<style>
  a {
    display: grid;
    background-color: var(--clr-cta);
    font-size: 1rem;
    color: var(--clr-cta-txt);
    font-weight: 700;
    text-transform: uppercase;
    border: 0;
    transition: background-color .2s ease-out;
    text-align: center;
    border-radius: var(--bd-rad);
    padding: 0.875rem;
    line-height: calc(4 / 3);
  }
  a:hover {
    background-color: var(--clr-cta-hvr);
  }
</style>